// Vocabulary in Context — word inside a natural sentence + 4 definition options
export const VOCAB_ITEMS = [
  {
    word: "GIGANTIC",
    sentence: "The blue whale is a gigantic animal in the ocean.",
    correct: "very large",
    distractors: ["tiny", "quiet", "friendly"],
  },
  {
    word: "FRAGILE",
    sentence: "Please carry the fragile glass vase carefully.",
    correct: "easy to break",
    distractors: ["shiny", "heavy", "old"],
  },
  {
    word: "DELICIOUS",
    sentence: "Grandma baked a delicious apple pie for us.",
    correct: "tasting very good",
    distractors: ["hot", "round", "cold"],
  },
  {
    word: "EXHAUSTED",
    sentence: "After the long run, the dog was exhausted.",
    correct: "very tired",
    distractors: ["excited", "hungry", "wet"],
  },
  {
    word: "COURAGEOUS",
    sentence: "The courageous firefighter rescued the kitten from the tree.",
    correct: "brave",
    distractors: ["tall", "loud", "sleepy"],
  },
  {
    word: "ANCIENT",
    sentence: "The museum showed ancient tools from long ago.",
    correct: "very old",
    distractors: ["broken", "new", "shiny"],
  },
  {
    word: "INVISIBLE",
    sentence: "The magician made the coin invisible with a wave.",
    correct: "unable to be seen",
    distractors: ["heavy", "loud", "sticky"],
  },
  {
    word: "CURIOUS",
    sentence: "The curious child asked question after question.",
    correct: "eager to learn",
    distractors: ["sad", "sleepy", "hungry"],
  },
  {
    word: "TRANQUIL",
    sentence: "The tranquil lake reflected the mountains perfectly.",
    correct: "calm and peaceful",
    distractors: ["stormy", "muddy", "crowded"],
  },
  {
    word: "GENEROUS",
    sentence: "It was generous of her to share her lunch.",
    correct: "willing to give freely",
    distractors: ["funny", "quick", "silent"],
  },
];
